import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getModalUtilityClass(slot) {
  return generateUtilityClass('JoyModal', slot);
}
const modalClasses = generateUtilityClasses('JoyModal', ['root', 'colorPrimary', 'colorNeutral', 'colorDanger', 'colorInfo', 'colorSuccess', 'colorWarning', 'variantPlain', 'variantOutlined', 'variantSoft', 'variantSolid']);
export default modalClasses;